import { getEntityRef } from "@client/content/lib/helper";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { connectCustom } from "@client/lib/misc";
import { type AppState, type EntityRef } from "@client/types";
import { apply, setShowingModal, showProfileAfterVote } from "../../../actions";
import { localStateSelector } from "../../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();

  return (state: AppState, props: EntityRef): MapProps => {
    const localState = localStateSelector(state, props);

    const vote = localState.vote!;
    return {
      apiInfo: apiInfoSelector(state, props),
      error: localState.error,
      id: props.id,

      isApplying: localState.status === "Applying",
      isMember: !!localState.current,
      mediaId: localState.source!.votedVideoMediaId,
      item: vote.item
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: EntityRef): ActionProps => ({
  onApply: () => dispatch(apply(getEntityRef(props), null)),
  onClose: () => dispatch(setShowingModal(getEntityRef(props), null)),
  onShowProfile: () => dispatch(showProfileAfterVote(getEntityRef(props)))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
